module.exports = __webpack_public_path__ + "media/images/pages/peel/collagen-939bc43c72ba4aaf04fa2142e204284f.svg";